import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { axiosQuery } from "../utils/axiosHelpers";
import { logger } from "../utils/logger";

interface PaypalCallbackResponse {
  paypalPaymentMethod: {
    paymentMethodId: string;
  };
}

const PAYPAL_PAYMENT_METHOD_MUTATION = gql`
  mutation PaypalPaymentMethod(
    $token: String!
    $isUnitedStates: Boolean!
    $paymentGatewayName: String!
  ) {
    paypalPaymentMethod(
      token: $token
      isUnitedStates: $isUnitedStates
      paymentGatewayName: $paymentGatewayName
    ) {
      paymentMethodId
    }
  }
`;

export const usePaypalCallback = (
  sessionToken: string,
  isUnitedStates: boolean,
  paymentGatewayName: string,
) =>
  useQuery<PaypalCallbackResponse>({
    queryKey: [
      "paypalCallback",
      sessionToken,
      isUnitedStates,
      paymentGatewayName,
    ],
    queryFn: () =>
      axiosQuery<PaypalCallbackResponse>(
        "PaypalPaymentMethod",
        PAYPAL_PAYMENT_METHOD_MUTATION,
        {
          isUnitedStates,
          paymentGatewayName,
          token: sessionToken,
        },
      ).catch((error) => {
        logger.error(`Error occurred when creating Paypal payment method`, {
          error,
        });
        throw error;
      }),
    retry: false,
    staleTime: Infinity,
    refetchOnMount: "always",
    enabled: !!sessionToken,
  });
